// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"760":"b4030d4a","953":"cea9c014"}[chunkId] + ".chunk.js");